<template>
  <div
    v-if="tripDetails && Object.keys(tripDetails).length > 0"
    class="app-layout-trip overflow-hidden"
  >
    <div class="px-2 py-3 app-layout-trip-map">
      <v-card elevation="0" class="pa-3 mb-2">
        <v-row v-if="tripDetails">
          <v-col cols="8" class="d-flex align-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <h2
                  class="mr-2 text-capitalize"
                  v-if="tripDetails.reference_number"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ tripDetails.reference_number }}
                </h2>
              </template>
              <span class="text-capitalize">reference number</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  class="mr-1 text-capitalize white--text font-weight-bold"
                  x-small
                  :class="
                    $helper.tripStatusColor(tripDetails.status.toLowerCase())
                  "
                  v-if="tripDetails.status"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ tripDetails.status }}
                </v-chip>
              </template>
              <span class="text-capitalize">{{
                statusMapping.tripStatus
              }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="4" class="text-right d-flex justify-end align-center">
            <div class="mr-4" v-if="tripDetails.trip_date">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <h5
                    v-bind="attrs"
                    v-on="on"
                    class="mr-2 text-capitalize"
                    v-if="tripDetails.trip_date"
                  >
                    {{ tripDetails.trip_date }}
                  </h5>
                </template>
                <span>Trip Date</span>
              </v-tooltip>
            </div>
          </v-col>
          <v-col cols="6">
            <v-card
              elevation="0"
              class="card-box-shadow pa-0 w-100 h-100"
              style="border-radius: 10px; overflow-y: auto"
            >
              <v-card-title class="px-3 py-2 d-flex justify-space-between">
                <h5 class="text-caption mr-1 font-weight-bold">
                  Assets Details
                </h5>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-subtitle>
                <v-row no-gutters>
                  <v-col cols="6" class="pb-1">
                    <TripTooltipWithIcon
                      v-if="
                        tripDetails &&
                        tripDetails.asset_details &&
                        tripDetails.asset_details.full_name
                      "
                      icon="mdi-account"
                      :text="tripDetails.asset_details.full_name"
                      label="driver name"
                    />
                  </v-col>
                  <v-col cols="6" class="pb-1">
                    <TripTooltipWithIcon
                      icon="mdi-phone"
                      v-if="
                        tripDetails &&
                        tripDetails.asset_details &&
                        tripDetails.asset_details.helper_name
                      "
                      :text="tripDetails.asset_details.helper_name"
                      label="helper name"
                    />
                  </v-col>
                  <v-col cols="6">
                    <TripTooltipWithIcon
                      class="pb-1"
                      v-if="
                        tripDetails &&
                        tripDetails.asset_details &&
                        tripDetails.asset_details.contact_number
                      "
                      icon="mdi-phone"
                      :text="tripDetails.asset_details.contact_number"
                      label="driver contact number"
                    />
                  </v-col>
                  <v-col cols="6" class="pb-1">
                    <TripTooltipWithIcon
                      icon="mdi-truck"
                      v-if="
                        tripDetails &&
                        tripDetails.asset_details &&
                        tripDetails.asset_details.vehicle_number
                      "
                      :text="tripDetails.asset_details.vehicle_number"
                      label="vehicle Number"
                    />
                  </v-col>
                </v-row>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <!-- 
      <v-row no-gutters class="py-lg-3 my-0">
        <v-col
          cols="12"
          lg="6"
          class="pt-3 pt-lg-0 pr-lg-2"
          v-if="tripDetails && tripDetails.driver_details"
        >
        </v-col>
        <v-col
          cols="12"
          lg="6"
          class="pl-lg-2 py-4 py-lg-0"
          v-if="tripDetails && tripDetails.vehicle_details"
        >
          <TripVehicleCard :detailsObj="tripDetails.vehicle_details" />
        </v-col>
      </v-row> -->
      <!-- 
        <div
          v-else
          class="h-100 w-100"
          style="display: flex; justify-content: center; align-items: center"
        >
          <h4 class="text-capitalize grey--text">
            There are no trips selected
          </h4>
        </div> -->

      <v-card elevation="0" class="mt-lg-1 h-100" ref="mapHeight">
        <GoogleMap
          :hasMapInfo="true"
          mapHeight="calc(100vh - 510px)"
          mapWidth="100%"
          ref="tripMap"
        >
          <template #mapInfo>
            <MapInfo
              legendType="trip"
              :actualRoute="actualRoute"
              :plannedRoute="plannedRoute"
              :referenceElement="$refs.tripMap"
            />
          </template>
        </GoogleMap>
      </v-card>

      <div elevation="0">
        <v-row
          no-gutters
          class="d-flex h-100 pt-lg-3"
          v-if="tripDetails && tripDetails.order_details"
        >
          <v-col
            cols="12"
            lg="6"
            class="pr-lg-2 pt-3 pt-lg-0"
            v-if="tripDetails.item_details"
          >
            <v-card
              elevation="0"
              class="card-box-shadow pa-0 w-100 h-100"
              style="border-radius: 10px; overflow-y: auto"
            >
              <v-card-title class="px-3 py-2 d-flex justify-space-between">
                <h5 class="text-caption mr-1 font-weight-bold">Item Details</h5>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-subtitle class="Item-Details-Height-Class">
                <v-row no-gutters>
                  <v-col
                    cols="6"
                    class="d-flex mb-4"
                    v-for="(
                      itemDetail, itemDetailIndex
                    ) in tripDetails.item_details"
                    :key="itemDetailIndex"
                  >
                    <v-btn
                      small
                      class="h-100 mr-3 primary--text btn-box"
                      depressed
                    >
                      <v-icon :color="itemDetail.storage_type_color" small
                        >mdi-checkbox-blank</v-icon
                      >
                    </v-btn>
                    <div class="mr-2">
                      <span
                        class="text-caption text-capitalize text_color--text"
                        >{{ itemDetail.storage_type_name }}</span
                      >
                      <h5>{{ itemDetail.times }}</h5>
                    </div>
                  </v-col>
                </v-row>
              </v-card-subtitle>
            </v-card>
          </v-col>

          <v-col cols="12" lg="6" class="pl-lg-2 py-4 py-lg-0">
            <v-card
              elevation="0"
              class="card-box-shadow pa-0 w-100"
              style="border-radius: 10px; overflow-y: auto"
            >
              <v-card-title class="px-3 py-2 d-flex justify-space-between">
                <h5 class="text-caption mr-1 font-weight-bold">
                  {{ orderModule.order }} Details
                </h5>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-subtitle>
                <v-row no-gutters>
                  <v-col
                    cols="6"
                    class="d-flex mb-4"
                    v-if="tripDetails.order_details.total_items"
                  >
                    <v-btn
                      small
                      class="h-100 mr-3 primary--text btn-box"
                      depressed
                    >
                      <v-icon color="indigo lighten-3" small
                        >mdi-alpha-i-box</v-icon
                      >
                    </v-btn>
                    <div class="mr-2">
                      <span class="text-caption text_color--text"
                        >Total {{ itemModule.itemPlural }}</span
                      >
                      <h5 class="text_color--text">
                        {{ tripDetails.order_details.total_items }}
                      </h5>
                    </div>
                  </v-col>
                  <v-col
                    cols="6"
                    class="d-flex mb-4"
                    v-if="tripDetails.order_details.total_orders"
                  >
                    <v-btn
                      small
                      class="h-100 mr-3 primary--text btn-box"
                      depressed
                    >
                      <v-icon color="indigo lighten-3" small
                        >mdi-archive</v-icon
                      >
                    </v-btn>
                    <div class="mr-2">
                      <span class="text-caption text_color--text"
                        >Total {{ orderModule.orderPlural }}</span
                      >
                      <h5 class="text_color--text">
                        {{ tripDetails.order_details.total_orders }}
                      </h5>
                    </div>
                  </v-col>
                  <v-col
                    cols="6"
                    class="d-flex mb-4"
                    v-if="tripDetails.order_details.volume"
                  >
                    <v-btn
                      small
                      class="h-100 mr-3 primary--text btn-box"
                      depressed
                    >
                      <v-icon color="indigo lighten-3" small>mdi-cube</v-icon>
                    </v-btn>
                    <div class="mr-2">
                      <span class="text-caption text_color--text"
                        >Total Volume</span
                      >
                      <h5 class="text_color--text">
                        {{ tripDetails.order_details.volume }}
                      </h5>
                    </div>
                  </v-col>
                  <v-col
                    cols="6"
                    class="d-flex mb-4"
                    v-if="tripDetails.order_details.weight"
                  >
                    <v-btn
                      small
                      class="h-100 mr-3 primary--text btn-box"
                      depressed
                    >
                      <v-icon color="indigo lighten-3" small>mdi-weight</v-icon>
                    </v-btn>
                    <div class="mr-2">
                      <span class="text-caption text_color--text"
                        >Total weight</span
                      >
                      <h5 class="text_color--text">
                        {{ tripDetails.order_details.weight }}
                      </h5>
                    </div>
                  </v-col>
                </v-row>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="pa-2">
      <v-card elevation="0" class="mb-3 rounded-lg">
        <v-card-title class="py-1">
          <h6 class="text_color--text">
            {{ orderModule.orderPlural }}
            <span v-if="orderList && orderList.length > 0"
              >({{ orderList.length }})</span
            >
          </h6>
        </v-card-title>
      </v-card>
      <v-card
        elevation="0"
        class="card-box-shadow overflow-y-auto app-list"
        style="overflow-y: auto; height: calc(100vh - 140px)"
        id="order-target"
      >
        <v-expansion-panels
          v-model="orderExpansion"
          flat
          multiple
          class="background_color"
        >
          <v-expansion-panel
            elevation="0"
            v-for="(order, i) in orderList"
            :key="i"
            class="px-3 py-1 ma-0 mb-2 card-box-shadow"
          >
            <OrderListCard :order="order" />
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </div>
  </div>
  <div v-else class="d-flex pt-4">
    <GoogleMap
      :hasMapInfo="false"
      mapHeight="90vh"
      style="width: 100%"
      ref="tripMapNew"
    />
  </div>
</template>

<script>
import { bus } from "@/main";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
import {
  tripModule,
  orderModule,
  statusMapping,
  itemModule,
} from "@/utils/moduleMapping";
import TripDriverCard from "@/components/ModuleBasedComponents/Consignee/TripDriverCard.vue";
import TripVehicleCard from "@/components/ModuleBasedComponents/Consignee/TripVehicleCard.vue";
import OrderListCard from "@/components/ModuleBasedComponents/Order/OrderListCard.vue";

export default {
  components: {
    GoogleMap,
    MapInfo,
    TripTooltipWithIcon,
    TripDriverCard,
    TripVehicleCard,
    OrderListCard,
  },
  data() {
    return {
      statusMapping,
      orderModule,
      itemModule,
      tripModule,
      search: null,
      orderList: [],
      tripDetails: {},
      routeDetails: {},
      clearableRoute: false,
      openOrderListDialog: false,
      openAssetChangeForm: false,
      plannedRoute: null,
      actualRoute: null,
      isVisibleMap: false,
      mapNewHeight: "100px",
    };
  },
  computed: {
    orderExpansion: {
      get() {
        return this.orderList.map((v, index) => index);
      },
      set(val) {
        return val;
      },
    },
    mapHeight() {
      let timer = setInterval(() => {
        if (
          this.$refs &&
          this.$refs.mapHeight &&
          this.$refs.mapHeight.$el &&
          !this.isVisibleMap
        ) {
          clearInterval(timer);
          this.mapNewHeight = `${this.$refs.mapHeight.$el.clientHeight}px`;
          this.isVisibleMap = true;
        }
      }, 200);
      return this.mapNewHeight;
    },
  },
  methods: {
    getData(id) {
      this.getTripDetails(id);
      // this.getTripRoute(id);
      this.getOrderList({ trip: id });
    },
    getOrderList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      bus.$emit("showLoader", true);
      this.$api.consigneeManagement
        .getConsigneeOrderList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.orderList = res.data;
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    getTripRoute(id) {
      bus.$emit("showLoader", true);
      this.$api.trip
        .getTripRoute(id)
        .then((res) => {
          let timer = setTimeout(() => {
            if (this.$refs.tripMap) {
              this.$refs.tripMap.clearGeoJson();
              this.$refs.tripMap.clearDriverRoute();
              this.$refs.tripMap.clearMarker();

              // clearInterval(timer);
              this.routeDetails = {};
              this.routeDetails = res.data;

              this.$refs.tripMap.setPlannedRoute(
                this.routeDetails.planned_route
              );
              this.$refs.tripMap.setLocation(
                this.routeDetails.driver_last_location,
                "driver_live_location"
              );
              this.plannedRoute = res?.data?.planned_route;

              setTimeout(() => {
                if (
                  this.routeDetails &&
                  this.routeDetails.actual_route &&
                  this.routeDetails.actual_route.features &&
                  this.routeDetails.actual_route.features.length != 0 &&
                  this.routeDetails.actual_route.features[0].geometry &&
                  this.routeDetails.actual_route.features[0].geometry
                    .coordinates
                ) {
                  this.actualRoute =
                    this.routeDetails.actual_route.features[0].geometry.coordinates;
                  this.$refs.tripMap.setDriverRoute(this.actualRoute);
                  this.clearableRoute = true;
                }
              }, 50);
            }
          }, 400);

          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getTripDetails(id) {
      bus.$emit("showLoader", true);
      this.$api.consigneeManagement
        .getConsigneeTripDetails(id)
        .then(({ data }) => {
          this.tripDetails = data;

          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style scoped>
.app-layout-trip {
  display: grid;
  grid-template-columns: 1fr 370px;
  height: 100%;
}
.app-layout-trip-map {
  /* display: grid; */
  /* grid-auto-rows: 200px 1fr 180px; 
  row-gap: 17px;  */
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 65px);
  display: flex;
  flex-direction: column;
}
.app-layout-trip-details {
  height: calc(100vh - 150px);
}
</style>
